import Enum from '/@/modules/core/app/helpers/Enum';

export default class EnumRelated extends Enum {
  static getValuesFromParentTypeKey(key, index = 'key') {
    return Object.values(this).filter((val) => val[index].startsWith(key));
  }

  static findValueFromChildTypeKey(key, index = 'key') {
    return Object.values(this).find((val) => key.startsWith(val[index]));
  }
}
